<template>
    <v-container style="margin-right: 0px;margin-left: 0px; margin-top: 20px; width: 100%;">
        <v-layout row wrap>
            <v-flex xs12 md6>
                <v-select name="yearCommercial" v-bind:label="$t('message.yearCommercial')" v-validate="'required'"
                    :error-messages="errors.collect('yearCommercial')" item-text="Valor" :items="yearCommercialList"
                    v-model="yearComercial" @change="getBusinessLine()"></v-select>
            </v-flex>
            <v-flex xs12 md6>
                <v-select name="lineBusiness" v-bind:label="$t('message.lineBusiness')" v-validate="'required'"
                    :error-messages="errors.collect('lineBusiness')" :items="catalogTypeOfLineBusiness" item-text="value"
                    v-model="lineBusiness"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="startWeek" v-bind:label="$t('message.startWeek')" v-validate="'required'"
                    :error-messages="errors.collect('startWeek')" item-text="Valor" :items="startWeekList"
                    v-model="startWeek"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="endWeek" v-bind:label="$t('message.endWeek')" v-validate="'required'"
                    :error-messages="errors.collect('endWeek')" item-text="Valor" :items="endWeekList"
                    v-model="endWeek"></v-select>
            </v-flex>

        </v-layout>
        <v-layout row wrap justify-end>
            <v-btn style="height:50%" class="hidden-xs-only" small color="accent"
                @click="CargaInformacion()">Visualizar</v-btn>
        </v-layout>
        <v-layout row wrap justify-center>
            <v-flex xs12 md5
                v-if="lineBusiness == 'INDIVIDUALES' && yearComercial < 2023 || lineBusiness == 'TODOS' && yearComercial < 2023">
                <Individuales ref="individuales" :tableIndividuales="tableIndividuales">
                </Individuales>
            </v-flex>
            <v-flex xs12 md5>
                <Corporativos v-if="lineBusiness == 'CORPORATIVO' || lineBusiness == 'TODOS'" ref="corporativos"
                    :dataCorporativo="dataCorporativo">
                </Corporativos>
            </v-flex>
           
            <v-flex xs12 md5>
                <Personas
                    v-if="lineBusiness == 'INDIVIDUALES' && yearComercial > 2022 || lineBusiness == 'TODOS' && yearComercial > 2022"
                    ref="personas" :dataPersonas="dataPersonas">

                </Personas>
            </v-flex>


        </v-layout>
        <h5 style=" margin-top:100px">Nota : En caso de tener duda en los indicadores, por favor comunícate con tu
            ejecutivo comercial.

        </h5>

    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CatalogServices from "@/services/CatalogsServices";
import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";
import Individuales from "./Individuales.vue";
import Corporativos from "./Corporativos.vue";
import Personas from "./Personas.vue";


export default {
    components: {
        Individuales,
        Corporativos,
        Personas
    },
    mounted() {

    },
    methods: {
        getBusinessLine() {

            if (this.yearComercial < 2023) {
                CatalogServices.getTypeLineBusiness()
                    .then((response) => {
                        if (response.data.error == 0) {

                            this.catalogTypeOfLineBusiness = response.data.data.filter(({ code }) => (code == "1" || code == "5" || code == "3"));
                            this.catalogTypeOfLineBusiness.unshift({ code: "0", value: "TODOS" });
                        } else {
                            this.catalogTypeOfLineBusiness = [];
                        }
                    })
                    .catch((res) => {
                        this.$root.$emit("showSnackBar", "Error desconocido", "error");
                    });

            } else {
                CatalogServices.getLineBusinessByYear()
                    .then((response) => {
                        if (response.data.error == 0) {
                            const indexOfCode17 = response.data.data.findIndex(item => item.code === "17");
                            if (indexOfCode17 !== -1) {
                            response.data.data[indexOfCode17].value = "INDIVIDUALES";
                            }

                            this.catalogTypeOfLineBusiness = response.data.data.filter(({ code }) => (code == "17" || code == "3"));
                            this.catalogTypeOfLineBusiness.unshift({ code: "0", value: "TODOS" });
                        } else {
                            this.catalogTypeOfLineBusiness = [];
                        }
                    })
                    .catch((res) => {
                        this.$root.$emit("showSnackBar", "Error desconocido", "error");
                    });


            }

        },
        async getApsInfo(apsId) {

            let idAps = "";
            await CatalogServices.getDataApsInfo()

                .then((response) => {
                    idAps = response.data.data.filter(({ codeSiaerp }) => (codeSiaerp == apsId))[0]["code"]


                }).catch(() => {
                    this.$root.$emit("hideLoading");
                    this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
                })
            if (idAps == "" || idAps == undefined || idAps == null) {
                this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
                this.$root.$emit("hideLoading");
            }

            return idAps;
        },

        async CargaInformacion() {
            this.$root.$emit(
                "showLoading",
                "Cargando Renovacion Bonos"
            );
            var broker = await this.getApsInfo(this.userProfile.user_id);   
            await CommercialGraphicsServices.getPresupuestoRenovacion(
                broker,
                this.yearComercial,
                this.startWeek,
                this.endWeek,
                "0",
                this.agencyName,
                this.lineBusiness == "INDIVIDUALES" ? "PERSONAS" : this.lineBusiness

            )
                .then((response) => {
                    console.log("Data")
                    console.log(response.data);
                    if (response.data.error == 0) {
                        if (this.lineBusiness == "INDIVIDUALES") {
                            this.tableIndividuales = response.data.data[0].presupuestoRenovacion;

                        } else if (this.lineBusiness == "CORPORATIVO") {
                            this.dataCorporativo = response.data.data[0].presupuestoRenovacion;
                        } else if (this.lineBusiness == "PERSONAS") {

                            this.dataPersonas = response.data.data[0].presupuestoRenovacion;
                            // this.$refs.fianzas.CargarInformacion();
                        }

                        else {
                            this.dataCorporativo = response.data.data[0].presupuestoRenovacion;
                           
                            if(this.yearComercial < 2022 ){
                                this.tableIndividuales = response.data.data[1].presupuestoRenovacion;

                            }else{
                                this.dataPersonas = response.data.data[1].presupuestoRenovacion;
                            }
                           

                        }

                    } else {
                        this.$root.$emit("hideLoading");
                        this.$root.$emit("showSnackBar", "No se obtuvo Información ", "error");
                        this.catalogTypeOfLineBusiness = [];
                    }
                })
                .catch((res) => {
                    this.$root.$emit("hideLoading");
                    this.$root.$emit("showSnackBar", "Error: " + res, "error");
                });
            this.$root.$emit("hideLoading");


        }

    },
    computed: {
        ...mapGetters(["agency", "userProfile", "agencyName"]),

    },
    data() {
        return {
            tableIndividuales: [],
            dataCorporativo: [],
            dataPersonas: [],
            catalogTypeOfLineBusiness: [],
            yearComercial: "",
            lineBusiness: "TODOS",
            startWeek: "",
            endWeek: "",
            yearCommercialList: [
                "2012",
                "2013",
                "2014",
                "2015",
                "2016",
                "2017",
                "2018",
                "2019",
                "2020",
                "2021",
                "2022",
                "2023",
                "2024",
                "2025",
                "2026",
                "2027",
                "2028",
                "2029",
                "2030",
                "2031",
                "2032",
                "2033",
                "2034",
                "2035",
                "2036",
                "2037",
                "2038",
                "2039",
                "2040",
                "2041",
                "2042",
                "2043",
                "2044",
                "2045",
                "2046",
                "2047",
                "2048",
                "2049",
                "2050"
            ],
            startWeekList: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
                "32",
                "33",
                "34",
                "35",
                "36",
                "37",
                "38",
                "39",
                "40",
                "41",
                "42",
                "43",
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "51",
                "52"
            ],
            endWeekList: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
                "32",
                "33",
                "34",
                "35",
                "36",
                "37",
                "38",
                "39",
                "40",
                "41",
                "42",
                "43",
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "51",
                "52"
            ],


        }
    }

}
</script>